import {
  FormattedDate,
  FormattedRelativeTime,
  parseDate,
  toPrimitiveDateInput,
} from '@superdispatch/dates';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { CalendarMonthIcon } from 'shared/icons';
import { PostingLoadDTO } from '../../data/dto/PostingLoadDTO';
import { PostingDescription } from './PostingDescription';

export function PostingPostedDate({
  posted_to_loadboard_at: dateProp,
}: PostingLoadDTO) {
  const primitiveInput = toPrimitiveDateInput(dateProp);
  const date = useMemo(
    () => parseDate(primitiveInput, { format: 'JodaISO' }),
    [primitiveInput],
  );
  const today = useMemo(() => DateTime.local(), []);

  const icon = (
    <CalendarMonthIcon
      aria-label="Posted date icon"
      color="action"
      fontSize="small"
    />
  );

  if (!date.isValid) {
    return (
      <PostingDescription label="Posted" icon={icon}>
        No Date
      </PostingDescription>
    );
  }

  return (
    <PostingDescription label="Posted on" icon={icon}>
      {date.hasSame(today, 'day') ? (
        <FormattedRelativeTime date={date} />
      ) : (
        <FormattedDate date={date} variant="Date" />
      )}
    </PostingDescription>
  );
}
